import script from "./Activity_InfoVer2.vue?vue&type=script&setup=true&lang=js"
export * from "./Activity_InfoVer2.vue?vue&type=script&setup=true&lang=js"

import "./Activity_InfoVer2.vue?vue&type=style&index=0&id=c6d8496e&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6d8496e"]])

export default __exports__